import { Box } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

const ActionsBar: FC<PropsWithChildren> = ({ children }) => {
  if (children === undefined) {
    return null;
  }

  return (
    <Box
      className="ActionsBar"
      sx={{
        display: 'flex',
        flexDirection: { sm: 'column', md: 'row' },
        flexWrap: 'wrap',
        gap: 0,
        height: '100%',
        '&:first-of-type': {
          borderLeft: '0 !important',
        },
        '> a, > button': {
          border: 'solid 1px rgb(230, 230, 230) !important',
          borderBottom: '0 !important',
          borderRight: '0 !important',
          flexGrow: 1,
          marginTop: 0,
        },
      }}
    >
      {children}
    </Box>
  );
};

export default ActionsBar;
